module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/wire-cf49debe1518c77d551985f3aa70153d.jpg";